import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DisclaimerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  backgroundColor: '#e3f2fd',
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
}));

export const DisclaimerContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  '> button': {
    width: 'fit-content',
    height: 'fit-content',
    padding: theme.spacing(0),
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    lineHeight: theme.typography.button.lineHeight,
    color: theme.palette.info.main,
  },
}));

export const DisclaimerText = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.body2.fontWeight,
  lineHeight: theme.typography.body2.lineHeight,
  color: theme.palette.text.primary,
}));
